var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('activity-component',{attrs:{"activity":_vm.activity,"description":_vm.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }